import { adminRoutes } from '@bettermode/domain/routes/web/admin'
import { dayjs } from '@tribeplatform/react-components/common/lib'
import { T } from '@tribeplatform/react-components/i18n'
import { useRouter } from '@tribeplatform/react-sdk'
import { Badge } from '@tribeplatform/react-ui-kit/Badge'
import { Tooltip } from '@tribeplatform/react-ui-kit/Tooltip'

import { useTrialStatus } from '../Billing/hooks/useTrialStatus.js'

export const TrialBadge = () => {
  const { Link } = useRouter()
  const { isTrialActive, trialEndDate, isLoading } = useTrialStatus()

  if (isLoading || !isTrialActive || !trialEndDate) {
    return null
  }

  const duration = dayjs(trialEndDate).fromNow(true)

  return (
    <Tooltip>
      <Tooltip.Trigger asChild>
        <Link
          href={adminRoutes.billing.plans}
          className="inline-flex items-center px-2"
        >
          <Badge variant="attention" size="md">
            <T
              defaultMessage="{duration} left in trial"
              id="Admin.TopNavBar.TrialBadge.DurationLeft"
              values={{ duration }}
            />
          </Badge>
        </Link>
      </Tooltip.Trigger>
      <Tooltip.Panel>
        <T
          defaultMessage="Your free trial ends in {duration}. Subscribe to keep your community live."
          id="Admin.TopNavBar.TrialBadge.Tooltip"
          values={{ duration }}
        />
      </Tooltip.Panel>
    </Tooltip>
  )
}
